import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetOperator = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/register`
    })
}

const GetFunction = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: userInfor,
        url: `${endpointURL}/api/auth/signin`
    })
}

const GetScripts = async (searchScript, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchScript, rowsPerPage, page },
        url: `${endpointURL}/api/workspace/get-scripts`
    })
}

const GetScriptName = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptID },
        url: `${endpointURL}/api/workspace/get-script-name`
    })
}

const GetProjects = async () => {
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/workspace/get-projects`
    })
}

const CreateNewScript = async (scriptInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptInfor },
        url: `${endpointURL}/api/workspace/create-new-script`
    })
}

const UpdateScript  = async (scriptInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptInfor },
        url: `${endpointURL}/api/workspace/update-script`
    })
}

const DeleteScript = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptID },
        url: `${endpointURL}/api/workspace/delete-script`
    })
}

const DuplicateScript = async (scriptInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptInfor },
        url: `${endpointURL}/api/workspace/duplicate-script`
    })
}

const GetScriptSteps = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: {scriptID},
        url: `${endpointURL}/api/workspace/get-script-steps`
    })
}

const GetFunctions = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/workspace/get-functions`
    })
}

const SaveScript = async (scriptID, scriptsteps) => {
    return Axios({
        method: 'POST',
        headers,
        data: {scriptID, scriptsteps},
        url: `${endpointURL}/api/workspace/save-script`
    })
}

const RunScript = async (scriptID, historiesID, scriptsteps, index) => {
    return Axios({
        method: 'POST',
        headers,
        data: {scriptID, historiesID, scriptsteps, index},
        url: `${endpointURL}/api/workspace/run-script`
    })
}

const InspectSelector = async (url, scriptsteps = [], index = 0, action = "") => {
    return Axios({
        method: 'POST',
        headers,
        data: { url, scriptsteps, index, action },
        url: `${endpointURL}/api/workspace/inspect-selector`
    })
}

const GetHistoriesID = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: {scriptID},
        url: `${endpointURL}/api/workspace/get-historiesid`
    })
}

const CloseBrowsers = async (scriptsteps) => {
    return Axios({
        method: 'POST',
        headers,
        data: {scriptsteps},
        url: `${endpointURL}/api/workspace/close-browsers`
    })
}

const GetHistories = async (scriptID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { scriptID },
        url: `${endpointURL}/api/workspace/get-histories`
    })
}

export {
    GetOperator,
    GetFunction,
    GetScripts,
    GetScriptName,
    GetProjects,
    CreateNewScript,
    UpdateScript,
    DeleteScript,
    DuplicateScript,
    GetScriptSteps,
    GetFunctions,
    SaveScript,
    RunScript,
    InspectSelector,
    GetHistoriesID,
    CloseBrowsers,
    GetHistories,
};
